import { render, staticRenderFns } from "./SetStatementPrice.vue?vue&type=template&id=516a71ea"
import script from "./SetStatementPrice.vue?vue&type=script&lang=js"
export * from "./SetStatementPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports